var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ transform: ("scale(" + _vm.scale + ")") })},[_c('canvas',{ref:"canvas",staticClass:"w-full h-full",style:({ height: _vm.height + 'px', width: _vm.width + 'px'})})])}
var staticRenderFns = []

export { render, staticRenderFns }